export const ANSWERS_PICKED = 'ANSWERS PICKED';
export const QUESTIONS_ANSWERED = 'QUESTIONS ANSWERED';
export const QUESTIONS_ASKED = 'QUESTIONS ASKED';
